import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/free-solid-svg-icons"
import Logo from "../../assets/images/CapBox.svg"
import { useNavigate } from "react-router-dom"
export default function Header({ setShowNav }) {

    const navigate = useNavigate()

    return (
        <>
            <header className="navigationHeader">
                <div className="container ">
                    <div className="navigationHeader__container">
                        <img className="navigationHeader__container_logo" src={Logo} alt="cap achat logo" onClick={() => navigate('/')}/>
                        <FontAwesomeIcon className="navigationHeader__container_icon" onClick={() => setShowNav(true)} icon={faBars} />
                    </div>
                </div>
            </header>
        </>
    )

}